import { DATA_DISPLAY_TYPES } from "@shared/components/table-implementation/bcl-table-data/data-display-type";
import { HEADER_DISPLAY_TYPES } from "@shared/components/table-implementation/bcl-table-data/header-display-type";
import { SORT_DIRECTIONS } from "@shared/components/table-implementation/types/sorting-directions";
import { TableConfig } from "@shared/components/table-implementation/types/table-config";
import { TableColumn } from "@shared/components/table-implementation/types/column/header.type";
import { COMBINATION_STRATEGIES, TABLE_FILTER_GROUP_TYPES, TableFilterGroup } from "@shared/components/table-implementation/types/filter/table-filter-group.type";
import { TABLE_FILTER_TYPES } from "@shared/components/table-implementation/types/filter/table-filter.type";


const TABLE_TRANSLATION_SCOPE: string = "feature/project-special-times-overview";
const HEADERS: TableColumn[] = [
  {
    field: "id",
    dataFields: [ "number" ],
    isRequiredField: true,
    translationInfo: {
      defaultText: "Nummer",
      token: "table-column-number",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.status,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: false, widthPx: 150 }
  },
  {
    field: "type",
    dataFields: [ "closing" ],
    isRequiredField: true,
    translationInfo: {
      defaultText: "Art der Sonderzeit",
      token: "table-column-type",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.status,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 230 }
  },
  {
    field: "datePeriod",
    dataFields: [ "date" ],
    isRequiredField: true,
    translationInfo: {
      defaultText: "Datum",
      token: "table-column-date",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.datePeriod,
    options: { sortDirection: SORT_DIRECTIONS.ASCENDING, isVisible: true, widthPx: 210 }
  },
  {
    field: "timePeriod",
    dataFields: [ "startTime", "endTime", "fullDay" ],
    isRequiredField: true,
    translationInfo: {
      defaultText: "Uhrzeit",
      token: "table-column-time",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.timePeriod,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 220 }
  },
  {
    field: "note",
    dataFields: [ "description" ],
    isRequiredField: true,
    translationInfo: {
      defaultText: "Anmerkung",
      token: "table-column-note",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.string,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 400 }
  },
  {
    field: "edit",
    translationInfo: {
      defaultText: "Bearbeiten",
      token: "table-column-edit",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.edit,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 120 }
  }
];
const FILTER_GROUPS: TableFilterGroup[] = [
  {
    selector: "type",
    groupNameTranslationInfo: {
      defaultText: "Sonderzeit-Typ",
      token: "table-filter-group-type",
      scope: TABLE_TRANSLATION_SCOPE
    },
    groupType: TABLE_FILTER_GROUP_TYPES.SINGLE_SELECT,
    combinationStrategy: COMBINATION_STRATEGIES.OR,
    children: [
      {
        selector: "type-opening",
        filterNameTranslationInfo: {
          defaultText: "Sonderöffnungszeit",
          token: "table-filter-type-opening",
          scope: TABLE_TRANSLATION_SCOPE
        },
        paramName: "closing",
        filterValue: {
          filterType: TABLE_FILTER_TYPES.SELECT,
          isSelected: false,
          value: "false"
        }
      },
      {
        selector: "type-closing",
        filterNameTranslationInfo: {
          defaultText: "Sonderschließzeit",
          token: "table-filer-type-closing",
          scope: TABLE_TRANSLATION_SCOPE
        },
        paramName: "closing",
        filterValue: {
          filterType: TABLE_FILTER_TYPES.SELECT,
          isSelected: false,
          value: "true"
        }
      }
    ]
  }
];

export const PROJECT_SPECIAL_TIMES_TABLE_CONFIG: TableConfig = {
  id: crypto.randomUUID(),
  isDefault: true,
  name: "Standardconfig",
  columnConfig: {
    columns: HEADERS,
    fieldsSortedByOptions: [ "datePeriod" ]
  },
  filterConfig: {
    filterGroups: FILTER_GROUPS
  }
};
